import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// The "Plugins" entry of the top bar: one menu for the whole line-up, so a new
// product is a new row here, not another link the phone header has no room
// for. Same interaction as AccountMenu: hover opens it on desktop, a tap
// toggles it on touch, and a click outside or Escape closes it.
const PRODUCTS = [
  { to: "/", name: "TrapMan", tagline: "nav.trapmanTagline" },
  { to: "/pitchman", name: "PitchMan", tagline: "nav.pitchmanTagline" },
];

export default function PluginsMenu() {
  const { t } = useTranslation("landing");
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  // The bar stays mounted across navigations (SiteLayout), so a menu left
  // open would follow the visitor onto the page they just picked.
  useEffect(() => setOpen(false), [location.pathname]);

  useEffect(() => {
    if (!open) return;
    const onPointerDown = (e) => {
      if (!rootRef.current?.contains(e.target)) setOpen(false);
    };
    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  return (
    <div ref={rootRef} className="relative inline-block group">
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="nav-trigger"
      >
        {t("nav.plugins")}
        <span aria-hidden="true" className="text-[10px] leading-none">▾</span>
      </button>
      {/* pt-2 bridges the gap between button and panel so hover doesn't drop. */}
      <div className={`absolute left-0 top-full pt-2 w-60 ${open ? "block" : "hidden"} group-hover:block z-50`}>
        <div className="bg-[#0a0a0c] border border-white/10 rounded-lg shadow-2xl py-1">
          {PRODUCTS.map((p) => (
            <Link
              key={p.to}
              to={p.to}
              onClick={() => setOpen(false)}
              className="nav-menu-item block px-4 py-2.5 hover:bg-white/5 transition-colors"
            >
              <span className="block text-sm font-semibold text-white">{p.name}</span>
              <span className="block text-xs font-normal text-[#A1A1AA]">{t(p.tagline)}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
